const seleniumSeoByPath = {
  '/': {
    title: 'Selenium Practice Website | Free Web Automation Exercises',
    heading: 'Selenium Practice Website for Automation Testing',
    description:
      'Free Selenium practice website with text boxes, alerts, iframes, dropdowns, tables, mouse actions, and more for automation testing students.',
  },
  '/text-box': {
    title: 'Selenium Text Box Practice',
    heading: 'Selenium Text Box Practice',
    description:
      'Practice Selenium WebDriver text input, clearing fields, and form interactions on a free text box automation example page.',
  },
  '/checkbox': {
    title: 'Selenium Checkbox Practice',
    heading: 'Selenium Checkbox Practice',
    description:
      'Practice selecting, verifying, and automating checkbox elements with this free Selenium WebDriver exercise page.',
  },
  '/radio-button': {
    title: 'Selenium Radio Button Practice',
    heading: 'Selenium Radio Button Practice',
    description:
      'Practice automating radio button selection and validation with real UI elements on this Selenium practice page.',
  },
  '/button': {
    title: 'Selenium Button Practice',
    heading: 'Selenium Button Practice',
    description:
      'Practice clicking buttons and validating UI responses with Selenium WebDriver on a free automation practice website.',
  },
  '/web-links': {
    title: 'Selenium Web Links Practice',
    heading: 'Web Links Example',
    description:
      'Practice automating links, navigation, and URL validation with Selenium WebDriver on this web links example page.',
  },
  '/drop-down': {
    title: 'Selenium Dropdown Practice',
    heading: 'Selenium Dropdown Practice',
    description:
      'Practice selecting options from dropdown menus and validating values with Selenium WebDriver automation exercises.',
  },
  '/calendar': {
    title: 'Selenium Calendar Practice',
    heading: 'Selenium Calendar Practice',
    description:
      'Practice date picker and calendar automation with Selenium WebDriver on this free web automation practice page.',
  },
  '/java-script-alert': {
    title: 'Selenium JavaScript Alert Practice',
    heading: 'JavaScript Alerts',
    description:
      'Practice handling JavaScript alerts, confirmations, and prompts with Selenium WebDriver on this alert example page.',
  },
  '/iframe': {
    title: 'Selenium Iframe Practice',
    heading: 'Selenium Iframe Practice',
    description:
      'Practice switching into iframes and automating elements inside frames with Selenium WebDriver exercises.',
  },
  '/nested-iframe': {
    title: 'Selenium Nested Iframe Practice',
    heading: 'Selenium Nested Iframe Practice',
    description:
      'Practice nested iframe handling and frame switching scenarios for Selenium WebDriver automation testing.',
  },
  '/multiple-windows': {
    title: 'Selenium Multiple Windows Practice',
    heading: 'Selenium Multiple Windows Practice',
    description:
      'Practice window and tab switching, child windows, and multi-window automation with Selenium WebDriver.',
  },
  '/swipe': {
    title: 'Selenium Swipe Gallery Practice',
    heading: 'Selenium Swipe Gallery Practice',
    description:
      'Practice swipe and carousel interactions with Selenium WebDriver on this mobile-style gallery automation page.',
  },
  '/mouse-actions': {
    title: 'Selenium Mouse Actions Practice',
    heading: 'Selenium Mouse Actions Practice',
    description:
      'Practice mouse hover, double click, drag and drop, and other mouse actions with Selenium WebDriver.',
  },
  '/scroll': {
    title: 'Selenium Scroll Practice',
    heading: 'Scroll Example with Buttons',
    description:
      'Practice scrolling pages and elements into view with Selenium WebDriver on this scroll automation example.',
  },
  '/web-table': {
    title: 'Selenium Web Table Practice',
    heading: 'Employee Table',
    description:
      'Practice reading web tables, rows, columns, and dynamic table data with Selenium WebDriver automation.',
  },
  '/synchronization': {
    title: 'Selenium Synchronization Practice',
    heading: 'Selenium Synchronization Practice',
    description:
      'Practice waits, synchronization, and timing issues with Selenium WebDriver on this automation practice page.',
  },
  '/javascript-executor': {
    title: 'Selenium JavaScript Executor Practice',
    heading: 'Selenium JavaScript Executor Practice',
    description:
      'Practice JavaScript Executor usage for clicks, input, and browser interactions with Selenium WebDriver.',
  },
  '/download-file': {
    title: 'Selenium Download File Practice',
    heading: 'Selenium Download File Practice',
    description:
      'Practice file download scenarios and browser file handling with Selenium WebDriver automation exercises.',
  },
  '/relative-locators': {
    title: 'Selenium Relative Locators Practice',
    heading: 'Selenium Relative Locators Practice',
    description:
      'Practice Selenium 4 relative locators such as above, below, left of, and right of on real web elements.',
  },
  '/buttons-with-messages': {
    title: 'Selenium Buttons with Messages Practice',
    heading: 'Selenium Buttons with Messages Practice',
    description:
      'Practice button clicks and message validation with Selenium WebDriver on this generic automation example page.',
  },
  '/sign-up': {
    title: 'Selenium Sign Up Form Practice',
    heading: 'Selenium Sign Up Form Practice',
    description:
      'Practice form filling, validation, and sign-up flow automation with Selenium WebDriver on this example page.',
  },
  '/forgotpasswords': {
    title: 'Selenium Forgot Password Practice',
    heading: 'Selenium Forgot Password Practice',
    description:
      'Practice forgot password and account recovery form automation with Selenium WebDriver exercises.',
  },
  '/verify-email': {
    title: 'Selenium Verify Email Practice',
    heading: 'Selenium Verify Email Practice',
    description:
      'Practice email verification form automation and input validation with Selenium WebDriver.',
  },
};

const defaultSeleniumSeo = {
  title: 'Selenium Practice Website | Free Web Automation Exercises',
  heading: 'Selenium Practice Website for Automation Testing',
  description:
    'Free Selenium practice website with real web elements for automation testing students learning WebDriver.',
};

module.exports = { seleniumSeoByPath, defaultSeleniumSeo };
